import React from "react";
import "./refundpolicy.css";

const RefundPolicy = () => (
  <div className="refund-policy-container">
    <h1>Refund and Cancellation Policy</h1>
    <h2>1. Overview</h2>
    <p>This policy outlines the conditions under which customers can request refunds and cancel services. It applies to all products and services offered by Cysigil Network Pvt Ltd., which adheres to PCI compliance standards to ensure secure transactions.</p>
    <h2>2. Refund Eligibility</h2>
    <ul>
      <li>Service Not Rendered: If a service was not delivered as promised or within the specified timeframe.</li>
      <li>Dissatisfaction: If the customer is unsatisfied with the service due to quality issues, provided that a reasonable effort to resolve the issue was made prior to the refund request.</li>
      <li>Incorrect Billing: In cases of erroneous charges or duplicate billing, customers are eligible for a full refund of the overcharged amount.</li>
    </ul>
    <p><strong>Time Frame for Refund Requests:</strong></p>
    <ul>
      <li>Refund requests must be submitted within 30 days of the service completion date or purchase date, whichever is applicable.</li>
    </ul>
    <h2>3. Cancellation of Services</h2>
    <ul>
      <li>Notice Requirement: A written notice of cancellation must be provided to customer support via email or through the customer portal at least 15 days prior to the next billing cycle or service delivery date.</li>
      <li>Immediate Cancellations: For month-to-month subscriptions, customers can cancel immediately, but charges for the current billing cycle will not be refunded.</li>
    </ul>
    <h2>4. Refund Process</h2>
    <ul>
      <li>Contact Customer Support: Reach out to our customer support team at <a href="mailto:info@cysigil.com">info@cysigil.com</a></li>
      <li>Provide Documentation: Include relevant details such as order number, date of purchase, and reason for the refund or cancellation request.</li>
      <li>Review Period: Our team will review the request within 5-7 business days and respond with a decision.</li>
    </ul>
    <h2>5. Processing Fees</h2>
    <ul>
      <li>Any fees associated with processing the transaction (e.g., payment processing fees) are non-refundable.</li>
      <li>In cases of refunds for services, customers will receive a refund for the service cost minus any non-refundable fees.</li>
    </ul>
    <h2>6. Exceptions to Refunds and Cancellations</h2>
    <ul>
      <li>Custom Services: Any service that has been tailored specifically to a customer’s requirements may not be eligible for a refund once the work has commenced.</li>
      <li>Digital Products: Once digital products (e.g., software, downloadable content) are accessed or downloaded, they are non-refundable.</li>
      <li>Promotional Offers: Services purchased under promotional offers may have specific terms that override this general policy.</li>
    </ul>
    <h2>7. Changes to Policy</h2>
    <p>Cysigil Network Pvt Ltd reserves the right to amend this refund and cancellation policy at any time. Customers will be notified of significant changes via email or through our website. Continued use of our services after changes indicates acceptance of the new policy.</p>
    <h2>8. Contact Information</h2>
    <p>For any questions regarding this policy or to initiate a refund or cancellation, please contact us at:<br />
    <a href="mailto:info@cysigil.com">info@cysigil.com</a></p>
  </div>
);

export default RefundPolicy;
